import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const MAX_NAME_LENGTH = 9;

const getDisplayName = (str = '') => {
  if (str) {
    if (str.length > MAX_NAME_LENGTH) {
      return str.slice(0, MAX_NAME_LENGTH) + '...';
    }
    return str;
  }

  return '';
};

const SDropdown = styled(Dropdown)`
  &.ui.dropdown > .text {
    font-weight: 400;
  }
`;

class UserMenu extends Component {
  render() {
    const { myProfile, logout } = this.props;
    return (
      <SDropdown
        text={getDisplayName(myProfile.firstname)}
        button
        floating
        className="primary circular"
      >
        <Dropdown.Menu>
          <Dropdown.Item text="ออกจากระบบ" onClick={logout} />
        </Dropdown.Menu>
      </SDropdown>
    );
  }
}

UserMenu.propTypes = {
  myProfile: PropTypes.shape({
    firstname: PropTypes.string,
  }),
  logout: PropTypes.func,
};

UserMenu.defaultProps = {
  myProfile: {},
  logout: () => {},
};

export default UserMenu;
